import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form, Input, message} from 'antd';
import {modal} from 'icsoc-antd-ex';
import tCallingNumberActions from 'Actions/systemSetting/callingNumber';
// import FormItem from 'antd/lib/form/FormItem';

const {ModalSize} = modal;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class EditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editLoading: false,
    };
  }

  componentDidMount() {}

  // 点击确定
  handleSubmit = () => {
    const {
      editModalData: {id} = {},
      pageStatus,
      form: {validateFields},
      getTableList,
      setEditModalVisible,
      actions,
    } = this.props;
    this.setState({
      editLoading: false,
    });
    validateFields((err, values) => {
      if (!err) {
        const params = {
          ...values,
          id,
        };
        this.setState({
          editLoading: true,
        });
        actions
          .editCallingNumber(params)
          .then(res => {
            const {payload: {code} = {}} = res || {};

            if (parseInt(code, 10) === 200) {
              setEditModalVisible();
              message.success('操作成功！');
              getTableList({...pageStatus});
            }
          })
          .finally(() => {
            this.setState({
              editLoading: false,
            });
          });
      }
    });
  };

  onChange = value => {
    // this.setState({value});
  };

  render() {
    const {
      editModalData: {
        phoneNum = '',
        id = '',
        phoneType = '',
        phoneBelong = '',
      } = {},
      form: {resetFields, getFieldDecorator},
      setEditModalVisible,
    } = this.props;
    const {editLoading} = this.state;

    return (
      <ModalSize
        title={`${id ? '配置' : '新增'}主叫号码`}
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setEditModalVisible}
        editLoading={editLoading}
        afterClose={() => {
          resetFields();
        }}>
        <Form>
          <FormItem {...formItemLayout} label="主叫号码">
            {getFieldDecorator('phoneNum', {
              initialValue: phoneNum,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: '主叫电话不得为空！',
                },
              ],
            })(<Input placeholder="请输入主叫电话" maxLength="15" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="电话类型">
            {getFieldDecorator('phoneType', {
              initialValue: phoneType,
              rules: [
                {
                  required: true,
                  message: '电话类型不得为空！',
                },
              ],
            })(<Input placeholder="请选择电话类型" maxLength="15" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="归属">
            {getFieldDecorator('phoneBelong', {
              initialValue: phoneBelong,
              rules: [
                {
                  required: true,
                  message: '归属不得为空！',
                },
              ],
            })(<Input placeholder="请选择归属" maxLength="15" />)}
          </FormItem>
        </Form>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({systemSettingCallingNumber}) => ({
  editModalData: systemSettingCallingNumber.editModalData,
  pageStatus: systemSettingCallingNumber.pageStatus,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tCallingNumberActions, dispatch),
});

const EditModalWrap = Form.create()(EditModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditModalWrap);
